import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {SoundManager} from "../sound/SoundManager";
import {BookOfShadowsGameConfig} from "../BookOfShadowsGameConfig";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {BookOfShadowsGameModuleConfig} from "../BookOfShadowsGameModuleConfig";
import {BookOfShadowsGameMode} from "../gameMode/BookOfShadowsGameMode";
import {BookOfShadowsSoundConfig} from "../BookOfShadowsSoundConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BookOfShadowsReelController} from "./BookOfShadowsReelController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {BookOfShadowsParsedGameData} from "../server/data/BookOfShadowsParsedGameData";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export class BookOfShadowsTimelineReelsController extends TimelineReelsController {

    private _gameData: BookOfShadowsParsedGameData;

    protected addEventListeners() {
        super.addEventListeners();

        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onReelBounceStarted(stopData: IReelStoppedData) {
        (Reels.getReel(stopData.reelId)! as BookOfShadowsReelController).reOrderSymbols();

        if (!stopData.quickStop) {
            if (BookOfShadowsGameConfig.instance.LOCKED_REEL[stopData.reelId] === "0" && stopData.reelId < 4) {
                this.handleAnticipation(stopData);
            }
        }

        if (stopData.reelId === (BookOfShadowsGameConfig.instance.LOCKED_REEL.lastIndexOf("0"))) {
            this.handleLastActiveReel(stopData.reelId);
        }

        if (BookOfShadowsGameConfig.instance.LOCKED_REEL[stopData.reelId] === "0") {
            this.handleReelLandingSounds(stopData);
        }

        super.onReelBounceStarted(stopData);
    }

    private onGameDataParsed(data: BookOfShadowsParsedGameData) {
        this._gameData = data;
    }

    private handleAnticipation(stopData: IReelStoppedData): void {
        const sAnticipationState: ISymbolStateConfig = BookOfShadowsGameConfig.instance.SYMBOL_STATES.sAnticipation;

        let nextReelId: number = 1;
        for (let i: number = stopData.reelId + 1; i < BookOfShadowsGameConfig.instance.LOCKED_REEL.length; i++) {
            if (BookOfShadowsGameConfig.instance.LOCKED_REEL[i] === "0") {
                nextReelId = i;

                break;
            }
        }

        if (this._gameData.nearWinReels[nextReelId]) {
            BookOfShadowsGameModuleConfig.nearWinView.playAnimation(nextReelId);

            if (!BookOfShadowsGameConfig.instance.ANTICIPATION_SOUND_PLAYED) {
                SoundManager.playAnticipation();
                BookOfShadowsGameConfig.instance.ANTICIPATION_SOUND_PLAYED = true;
            }

            this.changeStateForScatter(sAnticipationState, stopData.reelId);
        }
    }

    private handleLastActiveReel(id: number): void {
        const normalState: ISymbolStateConfig = BookOfShadowsGameConfig.instance.SYMBOL_STATES.normal;

        BookOfShadowsGameModuleConfig.nearWinView.stopAllAnimations();

        if (this._gameData.nearWinReels.indexOf(true) > -1) {
            this.changeStateForScatter(normalState, id);
        }

        if (this._gameData.mode === BookOfShadowsGameMode.NORMAL && this._gameData.nextMode.indexOf(BookOfShadowsGameMode.FREESPIN) === -1 && this._gameData.nearWinReels.indexOf(true) > -1) {
            BookOfShadowsGameModuleConfig.nearWinView.playCursedAnim();

            if (BookOfShadowsGameConfig.instance.ANTICIPATION_SOUND_PLAYED) {
                SoundManager.playAnticipationFail();
            }
        }

        SoundManager.stopSoundEffect(BookOfShadowsSoundConfig.instance.ANTICIPATION);
        BookOfShadowsGameConfig.instance.ANTICIPATION_SOUND_PLAYED = false;
        BookOfShadowsGameConfig.instance.FS_SPACIAL_SYMBOL_SOUND_PLAYED = false;

        BookOfShadowsGameConfig.instance.SCATTER_COUNT = 0;
    }

    /**
     * @description To changes the state of scatter symbol w.r.t. anticipation.
     * @param state
     * @param id
     */
    private changeStateForScatter(state: ISymbolStateConfig, id: number): void {
        for (let i = 0; i <= id; i++) {
            (Reels.getReel(i) as BookOfShadowsReelController).changeStateForScatter(state);
        }
    }

    private handleReelLandingSounds(stopData: IReelStoppedData): void {
        if ((stopData.fastSpin || stopData.quickStop) && (stopData.reelId % 2 === 0)) {
            SoundManager.playReelLanding(stopData.reelId);
        } else if ((!stopData.fastSpin && !stopData.quickStop)) {
            SoundManager.playReelLanding(stopData.reelId);
        }
    }
}